import React, {useContext, useEffect, useRef, useState} from 'react';
import {CorporationContext} from "../context/corporation-context.jsx";
import {Modal} from "../../../../components/modal/modal.jsx";
import Button from "../../../../components/button/button.jsx";
import {Card} from "../../../../components/card/card.jsx";
import projectUtils from "../../../../utils/project-utils.js";

const API_URL = import.meta.env.VITE_API_URL;

const CorporationImage = () => {
    const {state, setState, setChanges} = useContext(CorporationContext);
    const imgRef = useRef();
    const triggerInput = () => imgRef.current?.click();
    const [open, setOpen] = useState(false);
    const [imgScr, setImgScr] = useState(undefined);
    const [backgroundUrl, setBackgroundUrl] = useState(`url(${API_URL}/corporation/entity/image)`);

    const attachImage = ({target: {files}}) => {
        const file = files[0];
        const reader = new FileReader();

        if (file.size >= 2000000) {
            let message = 'Tamanho máximo de arquivo excedido. Limite: 2MB.';
            projectUtils.swalErrorMessage('', message, 'Ok');
            return;
        }

        reader.onload = function (e) {
            setImgScr(e.target.result);
        }

        reader.readAsDataURL(file);
        setState(prev => ({...prev, logoEntity: file}));
        setChanges("image");
    }

    const removeFile = (id) => {
        setState(prev => ({...prev, [id]: null}));
        setImgScr(null);
        setChanges("image");
    }

    const openModal = ({target}) => {
        if (target.classList.contains("btn-danger") || target.classList.contains("fa-close")) return;
        setOpen(true);
    }

    useEffect(() => {
        if (imgScr){
            setBackgroundUrl(`url(${imgScr})`);
        }else{
            setBackgroundUrl(`url(${API_URL}/corporation/entity/image)`)
        }
    }, [imgScr]);

    return (
        <>
            <Card className={"mb-2"}>
                <Card.Body>
                    <div className="image-effective">
                        <div
                            id="image-user"
                            onClick={openModal}
                            style={{
                                backgroundImage: backgroundUrl,
                                backgroundPosition: "50% center",
                                backgroundSize: "contain",
                                backgroundRepeat: "no-repeat",
                            }}
                            className="relative w-full aspect-[3/2] border border-[#e0e0e0] rounded-md bg-gray-100 cursor-pointer bg-center bg-no-repeat bg-contain"
                        >
                            {imgScr && (
                                <Button
                                    target={"danger"}
                                    onClick={() => removeFile("logoEntity")}
                                    title="Remover imagem"

                                    className="absolute top-2 right-2"
                                >
                                    <i className="fa fa-close"></i>
                                </Button>
                            )}
                        </div>

                        <input type="hidden" name="imageId" value={state.imageId ?? ""} />
                        <input
                            type="file"
                            accept="image/png, image/jpeg"
                            className="hidden"
                            name="image"
                            onChange={attachImage}
                            ref={imgRef}
                        />

                        <Button onClick={triggerInput} className="w-full mt-2">
                            Selecionar foto
                        </Button>

                        <small className="text-gray-500 text-xs">* Tamanho máximo 2MB</small>
                    </div>
                </Card.Body>
            </Card>

            <Modal id="expanded-img" open={open} setOpen={() => setOpen(false)} onClick={() => setOpen(false)}
                   centered size="lg" title={"Logo"}>
                <div className={"bg-center bg-no-repeat bg-contain overflow-hidden h-[500px]"}
                     style={{backgroundImage: `${backgroundUrl}`}}
                ></div>
            </Modal>
        </>
    );
};

export default CorporationImage;